import * as React from "react";
import styled, { css } from "styled-components";
import { useHistory } from "react-router-dom";
import * as moment from "moment-timezone";

import {
  BasicModal,
  BasicModalProps
} from "src/library/components/Modal";
import { Text } from "src/library/components/Text";
import { IOrder } from "src/core/orders/api/orders.api";
import { Button } from "src/library/components/Button";

interface PayOrderLaterWarningModalProps extends Omit<BasicModalProps, "title"> {
  order: IOrder;
  paymentRequiredBy: Date | null;
}

// Generates a modal warning user consequences of choosing to pay later
const PayOrderLaterWarningModal: React.ReactFCWithChildren<PayOrderLaterWarningModalProps> = ({
  open, onDismiss, order, paymentRequiredBy
}) => {
  const history = useHistory();

  const paymentRequiredByFormatted = React.useMemo(() => {
    if (paymentRequiredBy) {
      return ` by ${moment.utc(paymentRequiredBy).format("HH:MM DD MMMM YYYY")}`;
    }

    return "";
  }, [ paymentRequiredBy ]);

  return (
    <BasicModal
      open={open}
      onDismiss={onDismiss}
      title="Confirm Pay Later"
      body=""
    >
      <StyledPayOrderLaterWarningModal>
        <div className="note">
          <Text>
            {`Payment for this order is required ${paymentRequiredByFormatted}`}
          </Text>
        </div>

        <div className="note">
          <Text>
            {`By clicking confirm, you agree to pay for the order ${paymentRequiredByFormatted}. Failing to do this will result in the order not being delivered.`}
          </Text>
        </div>

        <div className="actions">
          <Button
            onClick={onDismiss}
            $buttonType="secondary"
          >
            Cancel
          </Button>

          <Button
            onClick={() => history.push(`/orders/${order.id}/order-placed`)}
            $buttonType="primary"
          >
            Confirm
          </Button>
        </div>

      </StyledPayOrderLaterWarningModal>
    </BasicModal>
  );
};

export default PayOrderLaterWarningModal;

const StyledPayOrderLaterWarningModal = styled.div`
  ${({ theme }) => css`
    .note {
      margin: ${theme.spacing.margins.md} 0;
    }

    .actions {
      display: flex;
      justify-content: space-between;
      padding-top: ${theme.spacing.padding.lg};
    }
  `}

`;
